module.exports = __webpack_public_path__ + "static/media/automation.f91b795b.webp";